import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { getLocationUrl, now } from '@slardar/sdk-web';
import { SDK_NAME, SDK_VERSION } from '../constants';
export var addEnvToSendEvent = function (ev, config) {
    // The data needs immediate injection during the reporting process
    var _a = config || {}, _b = _a.pid, pid = _b === void 0 ? '' : _b, _c = _a.viewId, viewId = _c === void 0 ? '' : _c;
    var extra = {
        url: getLocationUrl(),
        timestamp: now(),
        sdk_version: SDK_VERSION,
        sdk_name: SDK_NAME,
        pid: pid,
        view_id: viewId,
    };
    return __assign(__assign({}, ev), { extra: __assign(__assign({}, extra), (ev.extra || {})) });
};
export var InjectEnvPlugin = function (client) {
    client.on('report', function (ev) {
        return addEnvToSendEvent(ev, client.config());
    });
};
//# sourceMappingURL=inject-env.js.map